import { useEffect, useRef, useState } from 'react'
import Swal from 'sweetalert2'
import { createTicket } from '../../../Services/apiReports'
import { getByIdCuentasCorriente } from '../../../Services/cuentaCorrienteClienteService'
import { getAllMediosPagos } from '../../../Services/medioPagoService'
import { getAllTarjetas } from '../../../Services/tarjetaService'
import { saveVentas } from '../../../Services/ventaService'
import { determinarPrecio } from '../FacturaElectronicaModal/utils'

const useFinalizarVentaModal = (ventaDatos, handleShow, handleClose, isLoad, reset) => {
  let token = JSON.parse(atob(sessionStorage.getItem('token').split('.')[1]))

  // Con este ref controlo si el componente está montado
  const isMountedRef = useRef(true)

  const [mediosPagos, setMediosPagos] = useState([])
  const [medioPago, setMedioPago] = useState(1)

  const [tarjetas, setTarjetas] = useState([])
  const [tarjeta, setTarjeta] = useState(null)

  const [total, setTotal] = useState(0)
  const [saldo, setSaldo] = useState(0)
  const [monto, setMonto] = useState(0)
  const [recargoDescuento, setRecargoDescuento] = useState(0)

  const [cobrosParcializados, setCobrosParcializados] = useState([])

  // datos de la trajeta de credito
  const [nombreTitular, setNombreTitular] = useState('')
  const [numeroTarjeta, setNumeroTarjeta] = useState('')
  const [numeroLote, setnumeroLote] = useState('')
  const [cantidadCuotasTarjeta, setCantidadCuotasTarjeta] = useState(1)

  const [isCC, setIsCC] = useState(false)

  const [showFE, setShowFE] = useState(false)

  const isDisabledButton = !ventaDatos.itemsFactura ||
    ventaDatos.itemsFactura.length === 0 ||
    parseFloat(ventaDatos.total) === 0


  const handleShowFE = () => {
    setShowFE(true)
  }

  const handleCloseFE = () => {
    setShowFE(false)
  }

  //Custom Swal
  const Toast = Swal.mixin({
    toast: true,
    position: 'top',
    showConfirmButton: false,
    timer: 2000,
    onOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    },
  })

  useEffect(() => {
    if (isLoad) {
      // cargo los medios de pagos
      getAllMediosPagos()
        .then((res) => {
          if (isMountedRef.current) {
            setMediosPagos(res.data)
          }
        })
        .catch((error) => {
          if (isMountedRef.current) {
            console.log(error.response)
          }
        })

      // cargos las tarjetas
      getAllTarjetas(true, 0, '', 1000)
        .then((res) => {
          if (isMountedRef.current) {
            setTarjetas(res.data.content)
          }
        })
        .catch((error) => {
          if (isMountedRef.current) {
            console.log(error.response)
          }
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoad])

  useEffect(() => {
    return () => {
      isMountedRef.current = false
    }
  }, [])

  const handleShowFirst = () => {
    setMedioPago(1)
    setCobrosParcializados([])
    setSaldo(ventaDatos.total)
    setTotal(ventaDatos.total)
    setMonto(ventaDatos.total)
    if (ventaDatos.cliente.id.persona.dni !== 9999999) {
      getByIdCuentasCorriente(ventaDatos.cliente.id.persona.id)
        .then(async (data) => {
          if (isMountedRef.current) {
            setIsCC(true)
          }
        })
        .catch(async (error) => {
          if (isMountedRef.current) {
            setIsCC(false)
          }
        })
    }
    handleShow()
  }

  const agregarCobroParcializado = () => {
    //Validación para evitar que se ingrese un monto superior al total
    if (parseFloat(saldo) <= 0) {
      Toast.fire({
        title: 'Ya se ingreso el monto total de la venta.',
        type: 'warning',
      })
      return
    }

    // Valido que el monto no exceda el saldo pendiente
    if (parseFloat(monto) > parseFloat(saldo)) {
      Toast.fire({
        title: 'El monto ingresado excede el saldo pendiente a pagar',
        type: 'warning',
      })
      return
    }

    // Valido que el medio de pago no se repita
    let isPresent = false
    cobrosParcializados.forEach((item) => {
      if (parseInt(item.medioPago.id, 10) === parseInt(medioPago, 10))
        isPresent = true
    })

    if (parseInt(medioPago) === 4) {
      getByIdCuentasCorriente(ventaDatos.cliente.id.persona.id)
        .then((data) => {
          if (isMountedRef.current) {
            setIsCC(true)
          }
        })
        .catch((error) => {
          if (isMountedRef.current) {
            setIsCC(false)
          }
        })
    }

    if (isNaN(parseFloat(monto))) {
      Toast.fire({
        title: 'Ingrese un monto válido.',
        type: 'warning',
      })
      return
    }

    if (parseFloat(monto) === 0) {
      Toast.fire({
        title: 'El monto debe ser mayor a 0',
        type: 'warning'
      })
      return
    }

    if (isNaN(parseInt(medioPago))) {
      Toast.fire({
        title: 'Seleccione un método de pago',
        type: 'warning',
      })
      return
    }

    if (!isCC && parseInt(medioPago) === 4) {
      Toast.fire({
        title: 'El cliente no posee una cuenta corriente.',
        type: 'warning',
      })
      return
    }

    // filtramos el medio de pago seleccionado
    let mediopagoSelected = mediosPagos.filter(function (mp) {
      return mp.id === parseInt(medioPago, 10)
    })

    //No puede ingresarse 2 veces efectivo o CC
    if (
      isPresent &&
      (parseInt(mediopagoSelected[0].id, 10) === 1 ||
        parseInt(mediopagoSelected[0].id, 10) === 4)
    ) {
      Toast.fire({
        title: 'No puede ingresar dos veces este medio de pago',
        type: 'warning',
      })
      return
    }

    // VALIDACION RECARGO/DESCUENTO
    if (isNaN(parseFloat(recargoDescuento))) {
      Toast.fire({
        title: 'Debe ingresar un recargo o descuento valido',
        type: 'warning',
      })
      return
    }

    let itemCobroParcializado = {
      monto: parseFloat(monto),
      descuento: 0,
      recargo: 0,
      medioPago: mediopagoSelected[0],
    }

    if (parseInt(mediopagoSelected[0].id) === 2) {
      // filtramos la tarjeta seleccionada si selecciono la opcion
      if (!isNaN(parseFloat(tarjeta))) {
        let tarjetaSelected = tarjetas.filter(function (t) {
          return t.id === parseInt(tarjeta, 10)
        })
        itemCobroParcializado.tarjeta = tarjetaSelected[0]
        itemCobroParcializado.tarjetaDato = {
          lote: numeroLote,
          cupon: 0,
          numeroTarjeta,
          nombreTitular,
          cantidadCuotas: cantidadCuotasTarjeta,
        }
      } else {
        Toast.fire({
          title: 'Debe ingresar una tarjeta valida valido',
          type: 'warning',
        })
        return
      }
    }

    // CHEQUE
    if (parseInt(mediopagoSelected[0].id) === 3) {
      itemCobroParcializado.cheque = {
        monto: itemCobroParcializado.monto,
      }
    }

    // si es mayor que 0 entonces hay recargo
    if (parseFloat(itemCobroParcializado.recargo) > 0) {
      let recargo = parseFloat(
        monto * parseFloat(itemCobroParcializado.recargo / 100)
      )
      itemCobroParcializado.monto = monto
      setTotal(total + recargo)

      if (saldo + recargo - itemCobroParcializado.monto < 0) setSaldo(0)
      else setSaldo(saldo + recargo - itemCobroParcializado.monto)
    } else if (parseFloat(itemCobroParcializado.descuento) < 0) {
      let descuento = parseFloat(
        monto * parseFloat(itemCobroParcializado.descuento / 100)
      )
      itemCobroParcializado.monto = monto
      setTotal(total - descuento)

      if (saldo - descuento - itemCobroParcializado.monto < 0) setSaldo(0)
      else setSaldo(saldo - descuento - itemCobroParcializado.monto)
    }

    // agrego item a la tabla de cobro parcializados
    setCobrosParcializados([...cobrosParcializados, itemCobroParcializado])

    // Actualización del saldo pendiente
    const nuevoSaldo = parseFloat((saldo - parseFloat(monto)).toFixed(2))
    setSaldo(nuevoSaldo)

    //Reseteo
    setnumeroLote('')
    setNombreTitular('')
    setNumeroTarjeta('')
    setTarjeta(null)
    setMedioPago(1)
    setCantidadCuotasTarjeta(1)
    setMonto(nuevoSaldo) // Redondeo
  }

  const deleteItemCobroParcializado = (cb, key) => {
    const nuevoSaldo = parseFloat((saldo + parseFloat(cb.monto)).toFixed(2))
    setSaldo(nuevoSaldo)

    //determinamos si hubo un descuento o un recargo para volver a la normalidad el total
    if (parseFloat(cb.recargo) > 0) {
      // si > 0 hubo un recargo
      let recargo = parseFloat(cb.monto * parseFloat(cb.recargo / 100))
      setTotal(parseFloat((total - recargo).toFixed(2)))
    } else {
      // sino descuento
      let descuento = parseFloat(
        cb.monto * parseFloat(cb.descuento / 100)
      )
      setTotal(parseFloat((total + descuento).toFixed(2)))
    }

    let itemsDelete = cobrosParcializados.filter((cp, index) => {
      return (
        parseInt(cp.medioPago.id) !== parseInt(cb.medioPago.id) ||
        key !== index
      )
    })

    setCobrosParcializados(itemsDelete)
  }

  const finalizarVenta = async () => {
    if (cobrosParcializados.length <= 0) {
      Toast.fire({
        title: 'No se ingreso ninguna forma de pago.',
        type: 'info',
      })
      return
    }

    // VERIFICO SI LA SUMA DE PARCIALIZADOS Y EL TOTAL COINDICEN
    let sumaParcializados = 0.0
    cobrosParcializados.map(
      (cobros) => (sumaParcializados += Number(cobros.monto))
    )

    if (Number(sumaParcializados).toFixed(2) !== Number(total).toFixed(2)) {
      Toast.fire({
        title: 'La suma de los pagos debe ser igual al total de la venta.',
        type: 'info',
      })
      return
    }

    const caja = JSON.parse(sessionStorage.getItem('caja'))

    let venta = {
      total: parseFloat(total.toFixed(2)),
      numeroComprobante: ventaDatos.numeroComprobante,
      numeroComprobanteAfip: -1,
      tipoComprobante: { id: ventaDatos.tipoComprobante },
      sucursal: token.sucursal,
      cliente: ventaDatos.cliente,
      caja: { id: caja.id },
      puntoVenta: { id: caja.puntoVenta.id },
      // empleado: token.empleado,
      items: ventaDatos.itemsFactura,
      facturada: false,

    }

    let dataVentaRequest = {
      venta,
      medioPagos: cobrosParcializados,
      presupuestoId: ventaDatos.presupuestoId
    }

    try {
      saveVentas(dataVentaRequest)
        .then(async (res) => {
          if (!isMountedRef.current) return
          const ventaRes = res.data.venta
          const { cliente } = ventaRes
          const fecha = new Date(ventaRes.createdAt)
          Swal.fire({
            toast: true,
            position: 'top',
            showConfirmButton: false,
            type: 'success',
            title: 'Venta realizada.',
            timer: 2500,
          })
          await handleClose()
          await reset(true)
          const puntoVenta = JSON.parse(
            sessionStorage.getItem('ptoventa')
          )
          const ticket = await createTicket({
            nombreLocal:
              sessionStorage.getItem('tenant') || 'Magenta',
            propietario: {
              razonSocial:
                puntoVenta.datoFiscal.razonSocial || '',
              cuit: puntoVenta.datoFiscal.cuitCuil || '',
              domicilio:
                puntoVenta.datoFiscal.domicilioFiscal || '',
              condicionFiscal:
                puntoVenta.datoFiscal.condicionFiscal.nombre ||
                '',
            },
            cliente: {
              nombre: `${cliente.id.persona.nombre || ''} ${cliente.id.persona.apellido || ''}`,
              domicilio: cliente.id.persona.direccion || '',
              cuit:
                cliente.id.persona.cuilCuit ||
                cliente.id.persona.dni,
              condicionFiscal: cliente.id.nombre || '',
            },
            fecha: fecha.toLocaleDateString(),
            hora: fecha.toLocaleTimeString(),
            venta: {
              tipoComprobante:
                ventaRes.tipoComprobante.nombre || '',
              puntoVenta: puntoVenta.id,
              numComprobante: ventaRes.facturada
                ? ventaRes.numeroComprobanteAfip
                : ventaRes.numeroComprobante,
              items: ventaRes.items.map((i) => {
                if (i.departamento) {
                  const tasaIva = i.departamento.tasaIva
                  const precio = determinarPrecio(
                    i.precio * i.cantidad,
                    tasaIva,
                    ventaRes.tipoComprobante
                      .idTipoComprobante
                  )
                  return {
                    nombre: i.departamento.nombre,
                    cantidad: `${i.cantidad} x ${i.precio}`,
                    monto: precio,
                  }
                } else {
                  const tasaIva =
                    i.articulo.familia?.departamento.tasaIva
                  const precio = i.articulo.pesable
                    ? determinarPrecio(
                      i.precio,
                      tasaIva,
                      ventaRes.tipoComprobante.id
                    )
                    : determinarPrecio(
                      i.precio * i.cantidad,
                      tasaIva,
                      ventaRes.tipoComprobante.id
                    )
                  return {
                    nombre: i.articulo.nombre,
                    cantidad: i.articulo.pesable
                      ? `${i.cantidad} x ${i.articulo.precioFinal}`
                      : `${i.cantidad} x ${i.precio}`,
                    monto: precio,
                  }
                }
              }),
              medioPagos: cobrosParcializados.map((cp) => {
                return {
                  nombre: cp.medioPago.nombre,
                  monto: cp.monto,
                }
              }),
              cae: ventaRes.cae,
              caeVencimiento: ventaRes.caeVencimiento,
              facturada: ventaRes.facturada,
              subtotal: 0,
              descuentoRecargo: 0,
              iva0: 0,
              iva105: 0,
              iva21: 0,
              total: ventaRes.total,
              vuelto: 0,
              qr: '',
            },
            turno: 0,
          })
          if (!isMountedRef.current) return
          const contenido = encodeURI(ticket.data)
          let excelWindow = window.open('')
          excelWindow.document.write(
            `<iframe width='100%' height='100%' margin='0px' padding='0px' src='data:application/pdf;base64, ${contenido}'>
						</iframe>`
          )
        })
        .catch((error) => {
          console.error('Error al procesar la venta:', error)
          if (isMountedRef.current) {
            Swal.fire({
              type: 'error',
              title: 'No se pudo proceder con la venta.',
              timer: 2500,
            })
          }
        })
    } catch (error) {
      if (isMountedRef.current) {
        console.error(error.message)
      }
    }
  }

  const getVentaFE = () => {
    // VERIFICO SI LA SUMA DE PARCIALIZADOS Y EL TOTAL COINDICEN
    let sumaParcializados = 0.0
    cobrosParcializados.map(
      (cobros) => (sumaParcializados += Number(cobros.monto))
    )

    const caja = JSON.parse(sessionStorage.getItem('caja'))

    // completamos los datos de la venta
    let venta = {
      total: parseFloat(total.toFixed(2)),
      numeroComprobante: ventaDatos.numeroComprobante,
      numeroComprobanteAfip: -1,
      tipoComprobante: { id: ventaDatos.tipoComprobante },
      sucursal: token.sucursal,
      cliente: ventaDatos.cliente,
      caja: { id: caja.id },
      puntoVenta: { id: caja.puntoVenta.id },
      // empleado: token.empleado,
      items: ventaDatos.itemsFactura,
      facturada: true,
    }

    let dataVentaRequest = {
      venta,
      medioPagos: cobrosParcializados,
    }

    return dataVentaRequest
  }
  return {
    handleShowFirst,
    mediosPagos,
    medioPago,
    setMedioPago,
    monto,
    setMonto,
    recargoDescuento,
    setRecargoDescuento,
    tarjeta,
    setTarjeta,
    tarjetas,
    cantidadCuotasTarjeta,
    setCantidadCuotasTarjeta,
    nombreTitular,
    setNombreTitular,
    numeroTarjeta,
    setNumeroTarjeta,
    numeroLote,
    setnumeroLote,
    agregarCobroParcializado,
    cobrosParcializados,
    finalizarVenta,
    deleteItemCobroParcializado,
    getVentaFE,
    showFE,
    handleShowFE,
    handleCloseFE,
    isDisabledButton,
    total,
    saldo
  }
}

export default useFinalizarVentaModal